import { createContext } from 'react'

const SummitAttendeesCtx = createContext()

export default SummitAttendeesCtx
